// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--36GiS","bold":"title-module--bold--oeHdQ"};